const ArrowLeft = ({ className = '' }) => (
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    role="presentation"
    aria-hidden={true}
  >
    <title>Left Arrow</title>
    <g fillRule="evenodd">
      <path
        fill="currentColor"
        d="M6.41421296,12.9999993 L10.7071065,17.2928929 C11.0976308,17.6834172 11.0976308,18.3165821 10.7071065,18.7071064 C10.3165822,19.0976307 9.68341727,19.0976307 9.29289298,18.7071064 L3.29289298,12.7071064 C2.90236869,12.3165821 2.90236869,11.6834172 3.29289298,11.2928929 L9.29289298,5.29289286 C9.68341727,4.90236857 10.3165822,4.90236857 10.7071065,5.29289286 C11.0976308,5.68341715 11.0976308,6.31658213 10.7071065,6.70710642 L6.41421368,10.9999993 L19.9999998,10.9999993 C20.5522845,10.9999993 20.9999998,11.4477145 20.9999998,11.9999993 C20.9999998,12.552284 20.5522845,12.9999993 19.9999998,12.9999993 L6.41421296,12.9999993 Z"
      />
    </g>
  </svg>
);

ArrowLeft.propTypes = {
  className: PropTypes.string,
};

export default ArrowLeft;
